import { useMutation, useQuery } from 'react-query';

import { Capacitor } from '~capacitor-plugins/core';

import { canMockPrinting } from './canMock';
import { Printer, PrintJobOptions } from './definitions';
import { BadgePrinter } from './plugin';

const findBluetoothPrintersOptions = () => ({
  queryKey: ['printers', 'bluetooth'],
  queryFn: () => BadgePrinter.findBluetoothPrinters(),
  select: (data: { printers: Printer[] }) => data?.printers,
  refetchInterval: 30 * 1000, // Poll every 30s to ensure we know if the printer disconnects
  refetchOnWindowFocus: true,
  refetchOnMount: true,
  enabled:
    Capacitor.isPluginAvailable('BadgePrinter') &&
    (Capacitor.getPlatform() === 'ios' || canMockPrinting),
});

const printBadgeOptions = (options: PrintJobOptions) => ({
  mutationKey: ['printers', 'print', options],
  mutationFn: ({ badgeUrl }: { badgeUrl: string }) =>
    BadgePrinter.printBadge({ ...options, badgeUrl }),
});

export const useFindBluetoothPrinters = () => useQuery(findBluetoothPrintersOptions());

export const usePrintBadgeMutation = (options: PrintJobOptions) =>
  useMutation(printBadgeOptions(options));
